import React from 'react'
import Footer from '../components/Footer'
import TopNav from '../components/TopNav'
import GmaBanner from '../components/GmaBanner'

const SignatureEventsPage: React.FC = () => {
    return (
        <>
            <TopNav />
            <div className="container-fluid w-100 h-auto m-0 p-0">
                <img src="./img/afroconheader.jpg" className="img-fluid w-100 pt-4 mt-5 top-image" alt="AfrosCon signature event" style={{ height: '100%' }} />
            </div>
            <section className="" style={{ padding: '0', margin: 0 }}>
                <div className="container-fluid" style={{ padding: 0, margin: 0 }}>
                    <div className="row" style={{ padding: 0, margin: 0 }}>
                        <div className="col" style={{ padding: 0, margin: 0 }}>
                            <div className="text-center" style={{ backgroundColor: '#908068', color: 'black' }}>
                                <h1 className="text-uppercase py-1 subheading">Signature Events</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container">
                    <div className="row mt-5">
                        <div className="col">
                            <div className="text-center">
                                <h3 className="section-subheading text-muted">We host events throughout the year</h3>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div className="card mb-3" style={{ maxWidth: '100%' }}>
                                <div className="row g-0">
                                    <div className="col-12 col-sm-4">
                                        <img src="./img/events/faeday2026.png" className="img-fluid rounded-start" alt="..." />
                                    </div>
                                    <div className="col-12 col-sm-4">
                                        <div className="card-body text-center">
                                            <h5 className="card-title">Black Fae Day</h5>
                                            <p className="card-text" style={{ overflow: 'visible' }}>
                                                Black Fae Day is a celebration of Black&apos;s in fantasy. All fairies, elves, mermaids, and folk are invited to
                                                join in as we frolic, munch, and celebrate all things magical in the park. Professional photographs will be
                                                taken to capture the day. More information to come! #blackfaeday
                                                <br />
                                                <strong>
                                                    Saturday, May 9th 2026 | 12pm-5pm | <br />
                                                    Miller Park Pavilion, 2707 Redick Avenue, Omaha, NE 68111
                                                </strong>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-4">
                                        <iframe
                                            width="100%"
                                            height="415"
                                            src="https://www.youtube.com/embed/VwLUcn4RK4I"
                                            title="Black Fae Day YouTube Short"
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                            referrerPolicy="strict-origin-when-cross-origin"
                                            allowFullScreen
                                        ></iframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div className="card mb-3" style={{ maxWidth: '100%' }}>
                                <div className="row g-0">
                                    <div className="col-md-4">
                                        <iframe
                                            width="100%"
                                            height="415"
                                            src="https://www.youtube.com/embed/OWVctKLa6FQ?si=fdF5yUzWN0_Hn0S7"
                                            title="YouTube video player"
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                            referrerPolicy="strict-origin-when-cross-origin"
                                            allowFullScreen
                                        ></iframe>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="card-body" style={{ textAlign: 'left' }}>
                                            <h5 className="card-title text-center">Juneteenth Steampunk Tea Party Weekend 2026</h5>
                                            <p className="card-text" style={{ overflow: 'visible' }}>
                                                The theme for this year&apos;s Juneteenth Steampunk weekend, <strong>Timekeepers of Timbuktu</strong>, blends
                                                past, present, and future to envision new possibilities. Through immersive experiences, artistic expression,
                                                and community engagement, the weekend celebrates innovation, resilience, and the power of imagining
                                                ourselves as the architects of liberated futures. Think Victorian Wakanda meets Steampunk Ancient Mali.
                                                This celebration reflects the spirit of freedom, creativity, and collective joy.
                                            </p>
                                            <p className="card-text mb-1">
                                                <strong>Juneteenth STEAM-Punk Freedom Lab &amp; Family Day</strong>
                                                <br />
                                                Saturday, June 13, 2026 | 12pm-3pm
                                                <br />
                                                Barbara Weitz Community Engagement Center | 6001 Dodge Street, Omaha, NE, 68182
                                                <br />
                                                An interactive, hands-on space where community and families explore the meaning of freedom through
                                                creativity, history, science, and imagination.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <iframe
                                            width="100%"
                                            height="415"
                                            src="https://www.youtube.com/embed/f73_9rG8rcc"
                                            title="Juneteenth Steampunk recap video"
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                            referrerPolicy="strict-origin-when-cross-origin"
                                            allowFullScreen
                                        ></iframe>
                                    </div>
                                </div>
                                <div className="row g-0">
                                    <div className="col-md-4">
                                        <div className="card-body" style={{ textAlign: 'left' }}>
                                            <p className="card-text mb-1">
                                                <strong>21+ SteamPunk Vaudeville Show + Vendor Market</strong>
                                                <br />
                                                Saturday, June 13, 2026 | Doors open at 7pm-10pm
                                                <br />
                                                Church Art House | 3101 S 20th St, Omaha, NE 68108
                                                <br />
                                                Featuring nationally recognized, regional and local artists. Handcrafted art, jewelry, vintage
                                                costuming, and artifacts, and more.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="card-body" style={{ textAlign: 'left' }}>
                                            <p className="card-text mb-1">
                                                <strong>SteamPunk Dinner &amp; VIP Adventure</strong>
                                                <br />
                                                Sunday, June 14, 2026 | 6pm - 8pm
                                                <br />
                                                Bohemian Gardens | 1424 South 13th St, Omaha, NE 68108
                                            </p>
                                            <p className="card-text mb-1">
                                                <strong>VIP Ticket Includes:</strong>
                                            </p>
                                            <ul className="mb-1">
                                                <li>3-course dinner by Chef Djamil Bah-Traore, from House of Bah</li>
                                                <li>African + African American fusion food education</li>
                                                <li>Pre-Ball dance activity</li>
                                                <li>Lively conversation</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="card-body" style={{ textAlign: 'left' }}>
                                            <p className="card-text mb-1">
                                                <strong>The Grand Steampunk Ball</strong>
                                                <br />
                                                Sunday, June 14, 2026 | 8pm - 11pm
                                                <br />
                                                Bohemian Gardens | 1424 South 13th St, Omaha, NE 68108
                                            </p>
                                            <p className="card-text mb-1">
                                                <strong>Ball Ticket Includes:</strong>
                                            </p>
                                            <ul className="mb-3">
                                                <li>Live Music &amp; Dancing</li>
                                                <li>Interactive Story + Character-led interactions</li>
                                                <li>Specialty Desserts</li>
                                                <li>Portrait Studio</li>
                                                <li>Curated photography &amp; Costume Parade</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="row g-0">
                                    <div className="col-12">
                                        <div className="card-body text-center">
                                            <p className="card-text mb-3">
                                                <strong>
                                                    #BlackCosplay #Afrofuturism #BlackExcellence #Juneteenth2026 #SteampunkFashion #BlackJoy
                                                    #OmahaEvents #BlackJoy
                                                </strong>
                                            </p>
                                            <div className="d-flex flex-wrap justify-content-center gap-2 mt-2">
                                                <a
                                                    href="https://m4k691fqe81.typeform.com/to/JZ28nCpb"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="btn btn-dark"
                                                >
                                                    Become a Vendor
                                                </a>
                                                <a
                                                    href="https://m4k691fqe81.typeform.com/to/tVxN6cdp"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="btn btn-dark"
                                                >
                                                    Volunteer
                                                </a>
                                                <a
                                                    href="https://hotelsapp.onelink.me/fSyN/zn09fejv"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="btn btn-dark"
                                                >
                                                    Hotel Information
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div className="card mb-3" style={{ maxWidth: '100%' }}>
                                <div className="row g-0">
                                    <div className="col-md-4">
                                        <iframe
                                            width="100%"
                                            height="415"
                                            src="https://www.youtube.com/embed/tddUj8DG_No?si=dh4_gwtnktnEGe2K"
                                            title="YouTube video player"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                            referrerPolicy="strict-origin-when-cross-origin"
                                            allowFullScreen
                                        ></iframe>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="card-body text-center">
                                            <h5 className="card-title">Afrocon</h5>
                                            <p className="card-text" style={{ overflow: 'visible' }}>
                                                AfroCon is a day-long comic and gaming convention, with community conversations, workshops and vendors. It is a
                                                1-2 day festival of nerd culture and black culture with artists, vendors, food trucks, workshops,
                                                demonstrations, ESports games + tournaments, board gaming, cosplay and conference style community panels and
                                                conversations on a variety of topics.
                                                <br />
                                                <strong>
                                                    Saturday October 10th 2025 | 11am-7pm <br /> Metropolitan Community College Fort Omaha Campus
                                                </strong>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <iframe
                                            width="100%"
                                            height="415"
                                            src="https://www.youtube.com/embed/ApA_FHKW4TE?si=XDGNxU-ptz9LCuq0"
                                            title="YouTube video player"
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                            referrerPolicy="strict-origin-when-cross-origin"
                                            allowFullScreen
                                        ></iframe>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <GmaBanner />
                    </div>
                </div>
                <Footer />
            </section>
        </>
    )
}

export default SignatureEventsPage
